import { PREVIEW } from '../actionTypePrefixes';

/** Preview Catalog Query Actions */
export const CATALOG_PREVIEW_REQUEST = `${PREVIEW}/CATALOG_PREVIEW_REQUEST`;
export const CATALOG_PREVIEW_ERROR = `${PREVIEW}/CATALOG_PREVIEW_ERROR`;
export const CATALOG_PREVIEW_RESPONSE = `${PREVIEW}/CATALOG_PREVIEW_RESPONSE`;
